import request from '@/utils/request'

/**
 * 礼品卡相关API
 */
let GiftCardApi = {
  /**
   * 获取礼品卡列表
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  getList(data, errorback) {
    return request._post('/supplier/gift_card.gift_card/index', data, errorback);
  },
  /**
   * 礼品卡背景图片列表
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  getCardImageList(data, errorback) {
    return request._post('/supplier/gift_card.gift_card/cardImageList', data, errorback);
  },
  /**
   * 添加礼品卡
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  add(data, errorback) {
    return request._post('/supplier/gift_card.gift_card/add', data, errorback);
  },
  /**
   * 修改礼品卡
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  edit(data, errorback) {
    return request._post('/supplier/gift_card.gift_card/edit', data, errorback);
  },
  /**
   * 删除礼品卡
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  del(data, errorback) {
    return request._post('/supplier/gift_card.gift_card/delete', data, errorback);
  },
  /**
   * 获取礼品卡详情
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  detail(data, errorback) {
    return request._post('/supplier/gift_card.gift_card/detail', data, errorback);
  },
  /**
   * 修改礼品卡状态
   * @param {Object} data - 请求参数 {id: 礼品卡ID, status: 状态值}
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  status(data, errorback) {
    return request._post('/supplier/gift_card.gift_card/status', data, errorback);
  },
  /**
   * 礼品卡销售记录
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  salesRecord(data, errorback) {
    return request._post('/supplier/gift_card.gift_card/salesRecord', data, errorback);
  },
  /**
   * 礼品卡实例列表（已发行礼品卡查询）
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  instanceList(data, errorback) {
    return request._post('/supplier/gift_card.gift_card/instanceList', data, errorback);
  },
  /**
   * 礼品卡台账：按卡号/实例ID查询单卡详情+流水
   * @param {Object} data - 请求参数 { id: 实例id }
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  ledgerByCardNo(data, errorback) {
    return request._post('/supplier/gift_card.gift_card/ledgerByCardNo', data, errorback);
  },

  /**
   * 礼品卡绑定记录（同一张卡可被多人绑定）
   * @param {Object} data - 请求参数 { id: 实例id, page, list_rows }
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  bindingList(data, errorback) {
    return request._post('/supplier/gift_card.gift_card/bindingList', data, errorback);
  }

}

export default GiftCardApi;



// WEBPACK FOOTER //
// ./src/api/gift_card/gift_card.js